import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/bb74bfb/node_modules/@undataforum/gatsby-theme-base/src/components/mdx-page.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Copyright © 2020 United Nations`}</p>
    <p>{`All rights reserved.`}</p>
    <p>{`None of the materials provided on this web site may be used, reproduced or
transmitted, in whole or in part, in any form or by any means, electronic or
mechanical, including photocopying, recording or the use of any information
storage and retrieval system, except as provided for in the Terms and Conditions
of Use of United Nations Web Sites, without permission in writing from the
publisher.`}</p>
    <p>{`News-related material can be used as long as the appropriate credit is given and
the United Nations is advised.`}</p>
    <p>{`To request such permission or for further enquires, please visit the
`}<a parentName="p" {...{
        "href": "/contact"
      }}>{`contact page`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      